/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/books.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼

const Notice = () => {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '사탐', value: 3},
    {title: '과탐', value: 4},
    {title: '수시', value: 5}
  ];
  return (
    <main className="com_container p_books_notice">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_1">출간교재 공지</h2>
          <button className="com_btn orange s btn_plus">출간 교재 공지 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
            </div>
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">인쇄교재</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">디지털 교재</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="9%" />
                <col width="9%" />
                <col width="9%" />
                <col width="25%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>과목</th>
                  <th>제작 방법</th>
                  <th>내용</th>
                  <th>파일 다운로드</th>
                  <th>등록자</th>
                  <th>댓글</th>
                  <th>상세보기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>언어</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td className="td_left">
                    <Link to="/Books/Notice/Detail">[출간] 고난도 이지솔루션(2101)학년도 4종</Link>
                  </td>
                  <td>
                    <button className="btn_link blue">
                      정오표 <br />
                      부가자료
                    </button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Notice/Detail');
                      }}
                      className="btn_link blue"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>언어</td>
                  <td>
                    <button className="btn_link">디자털 교재</button>
                  </td>
                  <td className="td_left">[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                  <td>
                    <button className="btn_link blue">
                      정오표 <br />
                      부가자료
                    </button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Notice/Detail');
                      }}
                      className="btn_link blue"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>언어</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td className="td_left">[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                  <td>
                    <button className="btn_link blue">
                      정오표 <br />
                      부가자료
                    </button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Notice/Detail');
                      }}
                      className="btn_link blue"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>언어</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td className="td_left">[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                  <td>
                    <button className="btn_link blue">
                      정오표 <br />
                      부가자료
                    </button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Notice/Detail');
                      }}
                      className="btn_link blue"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>45</td>
                  <td className="td_date">2022,08,25</td>
                  <td>언어</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td className="td_left">[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                  <td>
                    <button className="btn_link blue">
                      정오표 <br />
                      부가자료
                    </button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Notice/Detail');
                      }}
                      className="btn_link blue"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>44</td>
                  <td className="td_date">2022,08,25</td>
                  <td>언어</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td className="td_left">[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                  <td>
                    <button className="btn_link blue">
                      정오표 <br />
                      부가자료
                    </button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Notice/Detail');
                      }}
                      className="btn_link blue"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>43</td>
                  <td className="td_date">2022,08,25</td>
                  <td>언어</td>
                  <td>
                    <button className="btn_link">인쇄 교재</button>
                  </td>
                  <td className="td_left">[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                  <td>
                    <button className="btn_link blue">
                      정오표 <br />
                      부가자료
                    </button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Notice/Detail');
                      }}
                      className="btn_link blue"
                    >
                      보기
                    </button>
                  </td>
                </tr>

                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>43</td>
                      <td className="td_date">2022,08,25</td>
                      <td>언어</td>
                      <td>
                        <button className="btn_link">인쇄 교재</button>
                      </td>
                      <td className="td_left">[출간] 고난도 이지솔루션(2101)학년도 4종</td>
                      <td>
                        <button className="btn_link blue">
                          정오표 <br />
                          부가자료
                        </button>
                      </td>
                      <td>김길동103</td>
                      <td>8</td>
                      <td>
                        <button
                          onClick={() => {
                            navigate('/Books/Notice/Detail');
                          }}
                          className="btn_link blue"
                        >
                          보기
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
        </section>
      </div>
    </main>
  );
};

export default Notice;
